import { useEffect } from 'react';

type SeoOptions = {
  title: string;
  description: string;
  pathname?: string;
  image?: string;
};

const defaultTitle = 'Kisapuk Community Initiative';
const defaultDescription = 'Kisapuk Community Initiative empowers Maasai women, ends FGM, and builds sustainable community programs in Kenya.';
const defaultImage = 'https://your-domain.com/social-share.png';

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  if (!content) return;
  let element = document.querySelector<HTMLMetaElement>(`meta[${attr}='${key}']`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }
  element.content = content;
}

function setLink(rel: string, href: string) {
  let element = document.querySelector<HTMLLinkElement>(`link[rel='${rel}']`);
  if (!element) {
    element = document.createElement('link');
    element.rel = rel;
    document.head.appendChild(element);
  }
  element.href = href;
}

function getUrl(pathname?: string) {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  if (!pathname) return origin;
  return `${origin}${pathname.startsWith('/') ? pathname : `/${pathname}`}`;
}

export function setSeo({ title, description, pathname, image }: SeoOptions) {
  const pageTitle = `${title} | ${defaultTitle}`;
  document.title = pageTitle;
  setMeta('name', 'description', description || defaultDescription);
  setMeta('property', 'og:title', pageTitle);
  setMeta('property', 'og:description', description || defaultDescription);
  setMeta('property', 'og:type', 'website');
  setMeta('property', 'og:url', getUrl(pathname));
  setMeta('property', 'og:image', image || defaultImage);
  setMeta('name', 'twitter:card', image ? 'summary_large_image' : 'summary');
  setMeta('name', 'twitter:title', pageTitle);
  setMeta('name', 'twitter:description', description || defaultDescription);
  setMeta('name', 'twitter:image', image || defaultImage);
  setMeta('name', 'theme-color', '#0f766e');
  setLink('canonical', getUrl(pathname));
}

export function useSeo(options: SeoOptions) {
  useEffect(() => {
    setSeo(options);
  }, [options]);
}
